import { makeStyles } from "@mui/styles";

export const sectionTitleStyles = makeStyles(() => ({
  section_title__root: {
    width: '100%',
    height: '3rem',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  section_title__menu_button: {
    position: 'absolute',
    left: '0.5rem',
    top: '0.01em',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '10px',
    fontWeight: '400',
    letterSpacing: '0.03em',
    color: 'inherit',
    padding: '0.5rem',
    fontFamily: 'AvenirNextMedium',
    zIndex: 10,
    pointerEvents: 'all',
    '&:hover': {
      opacity: 0.7,
    }
  },
  section_title__text: {
    maxWidth: '50vw',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    pointerEvents: "all"
  }
}));
